import {getHubUrl, getNodeId, REQUEST_FAILED, REQUEST_STARTED, REQUEST_SUCCESSFUL} from "./constants";
import axios from "axios";
import {getSessionCookie} from "../utils/auth";
import {hubResponses} from "./hubResponseMocks";
import { navigate } from "../utils/navigation";
import { EventSourcePolyfill } from "event-source-polyfill";

export const requestStarted = () => ({
    type: REQUEST_STARTED,
});

export const requestSuccessful = ({ data }) => ({
    type: REQUEST_SUCCESSFUL,
    data,
});

export const requestFailed = ({ error }) => ({
    type: REQUEST_FAILED,
    error,
});


export function getFromHub(path, successCallback, errorCallback) {
    return hubRequest('GET', path, null, successCallback, errorCallback);
}

export function postToHub(path, payload, successCallback, errorCallback) {
    return hubRequest('POST', path, payload, successCallback, errorCallback);
}

export function putToHub(path, payload, successCallback, errorCallback) {
    return hubRequest('PUT', path, payload, successCallback, errorCallback);
}

export function deleteFromHub(path, successCallback, errorCallback) {
    return hubRequest('DELETE', path, null, successCallback, errorCallback);
}

async function hubRequest(method, path, payload, successCallback = () => {}, errorCallback = () => {}) {
    try {
        const nodeId = getNodeId();

        const response = await axios({
            method,
            url: getHubUrl() + path,
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'SessionId': getSessionCookie(),
                ...nodeId ? {'NodeId': nodeId} : {}
            },
            data: payload,
        });
        successCallback(response.data);
        return response.data;
    }
    catch (e) {
        console.error("Hub request, network error", e, e.response);
        if(e.response && e.response.status === 403) {
            // log user out
            navigate('/logout');
        }
        else {
            errorCallback(e);
            // throw e;
        }
    }
}

export async function getBlobFromHub(path) {
    try {
        const response = await axios({
            method: 'GET',
            url: getHubUrl() + path,
            responseType: 'blob',
            withCredentials: true,
            headers: {
                'Accept': '*/*',
                'SessionId': getSessionCookie(),
            },
        });
        const blob = new Blob([response.data], {type : 'application/vnd.ms-excel'});
        return blob;
    }
    catch (e) {
        console.error("Get blob network error", e);
        if(e.response && e.response.status === 403) {
            // log user out
            navigate('/logout');
        }
    }
}

export async function mockFromHub(path) {
    if(hubResponses.hasOwnProperty(path)) {
        await new Promise(resolve => setTimeout(resolve, 200 + (Math.random() * 1000)));
        return hubResponses[path];
    }
    else {
        return {error: true, message:"go to mocks and implement this endpoint mock"}
    }
}

export function createEventSourceConnection() {
    try {
        const nodeId= getNodeId();
        
        const eventSource = new EventSourcePolyfill(
            getHubUrl() + "broadcast/backoffice/register",
            {
                headers: {
                    Accept: "text/event-stream",
                    SessionId: getSessionCookie(),
                    ...nodeId ? {'NodeId': nodeId} : {}
                },
                heartbeatTimeout: 5 * 60 * 1000 // 5 min
            }
        );

        eventSource.onopen = () => {
            console.log("SSE connected");
        };

        eventSource.onerror = (error) => {
            console.error("EventSource connection error", error);
        };

        return eventSource;
    } catch (error) {
        console.error("Failed to create EventSource connection", error);
        return null;
    }
}